"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Hide = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M13.724 9H5.786C5.352 9 5 8.664 5 8.25s.352-.75.786-.75h7.938l-1.529-1.72a.818.818 0 0 1 0-1.06.616.616 0 0 1 .943 0l2.667 3c.26.293.26.767 0 1.06l-2.667 3a.616.616 0 0 1-.943 0 .818.818 0 0 1 0-1.06L13.724 9zm-8.39 5.545c.368 0 .666.326.666.728 0 .401-.298.727-.667.727H2c-1.105 0-2-.977-2-2.182V2.182C0 .977.895 0 2 0h3.333C5.702 0 6 .326 6 .727c0 .402-.298.728-.667.728H2c-.368 0-.667.325-.667.727v11.636c0 .402.299.727.667.727h3.333z"
}));

var _default = Hide;
exports.default = _default;